export default "__VITE_ASSET__D2fa8JXL__"